import React, { useState } from "react";
import csLogo from '../../assets/images/cybersquare_logo.png'
import successIcon from '../../assets/images/signupSuccessIcon.svg'
import inactiveLinkIcon from '../../assets/images/inactive-link.svg'
import './student-registration.css'
import { IconContext } from 'react-icons';
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import { jsPDF } from 'jspdf';


const StudentRegistrationStatus = ({ status, data, response }) => {

    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword((prevShowPassword) => !prevShowPassword);
    };

    const donwloadCred = async () => {

        const doc = new jsPDF();

        const imgLogo = 'https://99lmsfileuploadfolder.s3.ap-south-1.amazonaws.com/uploaded/companyLogo/companyLogo_r3qg8pxn.png';
        doc.addImage(imgLogo, 'PNG', 79, 10, 60, 15);

        doc.setFontSize(16);
        doc.text(`Welcome ${data.firstName}!`, 20, 40);

        doc.setFontSize(12);
        doc.text("Congratulations on joining Cyber Square! We're excited to have you", 20, 50);
        doc.text("as part of our learning community.", 20, 55);
        doc.text("Reminder: Please make sure to save your login credentials", 20, 66);
        doc.text("in a safe place.", 20, 71);
        doc.text("Welcome aboard, and happy learning!", 20, 82);

        const boxX = 20, boxY = 90, boxWidth = 170, boxHeight = 60;
        doc.setLineWidth(0.3);
        doc.roundedRect(boxX, boxY, boxWidth, boxHeight, 3, 3);

        const credentialsText = "Credentials";
        const textWidth = doc.getTextWidth(credentialsText);
        const credentialsX = boxX + (boxWidth - textWidth) / 2;

        doc.setFontSize(14);
        doc.setFont("helvetica", "bold");
        doc.text(credentialsText, (credentialsX - 3), boxY + 10);

        // Company URL text and padding
        const companyUrlText = `${data.companyUrl}`; // The text to be displayed inside the gray box
        const textPadding = 5; // Padding around the text
        const companyUrlWidth = doc.getTextWidth(companyUrlText) + (2 * textPadding); // Width of text plus padding

        const urlBoxX = boxX + (boxWidth - companyUrlWidth) / 2;
        const urlBoxY = boxY + 16;
        const urlBoxWidth = 110;
        const urlBoxHeight = 10;
        const cornerRadius = 3;
        doc.setFillColor(211, 211, 211);
        doc.roundedRect((urlBoxX - 10), urlBoxY, urlBoxWidth, urlBoxHeight, cornerRadius, cornerRadius, 'F');

        doc.setFontSize(12);
        doc.setFont("helvetica", "normal");
        doc.text(companyUrlText, urlBoxX + textPadding, urlBoxY + 7);

        doc.text(`Username: ${data.userName}`,  boxX + 45, boxY + 38);
        doc.text(`Password: ${data.password}`, boxX + 45, boxY + 48);

        doc.save("download.pdf");
    }

    return (
        <>

            <div className='col-sm-8 col-md-7 col-lg-6 col-xl-5 col-12 p-4 rounded-4 form'>
                {status === 200 ? (
                    <div className="col-12 mt-0" style={{ display: 'flex', justifyContent: 'center' }}>
                        <img src={csLogo} alt="cs_logo" style={{ width: '300px' }} />
                    </div>
                ) : (null)}

                <div className="col-12 mt-5" style={{ display: 'flex', justifyContent: 'center' }}>
                    <img style={{ width: status === 200 ? '30%' : '' }} alt="status_image" src={status === 200 ? successIcon : inactiveLinkIcon} />
                </div>
                <div className="col-12" style={{ display: 'flex', justifyContent: 'center' }}>
                    <span style={{ fontWeight: '300', textAlign: 'center' }}>
                        {status === 200 ? "You're almost there! Your registration is now awaiting teacher approval. We'll send you a confirmation email once it's approved." : 'This link is inactive now! please contact your teacher for further queries'}</span>
                </div>
                {status === 200 ? (
                    <>
                        <div className="text-center mb-5 mb-md-5 mt-5 mt-md-4 col-12" style={{ display: 'flex', justifyContent: 'center' }}>
                            <div className="text-center col-12 dwnld-box">
                                <div className="text-center col-12 mt-2 mb-2" style={{ display: 'flex', justifyContent: 'center' }}>
                                    <div className="text-center col-10 mt-2 mb-2">
                                        <span style={{ fontSize: '13px', fontWeight: 400 }}>Once it’s approved you can login using this url and credentials</span>
                                    </div>
                                </div>

                                <div className="text-center col-12 mt-2 mb-2" style={{ display: 'flex', justifyContent: 'center' }}>
                                    <div className="col-10 linkBox">
                                        <a className="company-url" target="_blank" rel="noreferrer" href={`http://${data.companyUrl}`} >{data.companyUrl}</a>
                                    </div>
                                </div>

                                <div class="container text-center">
                                    <div class="row">
                                        <div class="col-md-8 offset-md-3">
                                            <div class="row g-3 align-items-center">
                                                <div class="col-auto">
                                                    <label for="inputPassword6" class="col-form-label">Username :</label>
                                                </div>
                                                <div class="col-auto">
                                                    <span className="text" >{data.userName}</span>
                                                </div>
                                            </div>

                                            <div class="row g-3 align-items-center">
                                                <div class="col-auto">
                                                    <label for="inputPassword6" class="col-form-label">Password :</label>
                                                </div>
                                                <div class="col-auto">
                                                    <span className="text" >
                                                        {!showPassword ? (
                                                            <>
                                                                <span class="dot"></span>
                                                                <span class="dot"></span>
                                                                <span class="dot"></span>
                                                                <span class="dot"></span>
                                                                <span class="dot"></span>
                                                                <span class="dot"></span>
                                                            </>
                                                        ) : (data.password)}
                                                    </span>
                                                </div>
                                                <div class="col-auto">
                                                    <IconContext.Provider value={{ size: '1.5em' }}>
                                                        <span className='input-group-text' onClick={togglePasswordVisibility} style={{ border: 'none', cursor: 'pointer', backgroundColor: 'transparent'}}>
                                                            {!showPassword ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                                                        </span>
                                                    </IconContext.Provider>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div className=" mb-3 mb-md-3 mt-3 mt-md-3 col-12" style={{display: 'flex', justifyContent: 'center'}}>
                                    <div className="col-6" style={{display: 'flex', justifyContent: 'center'}}>
                                        <button type="button" className="submit-btn" 
                                        data-testid='signInButton' onClick={donwloadCred} >Download Credentials</button>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </>


                ) : (null)}

            </div>
        </>
    )

}
export default StudentRegistrationStatus